"use strict";

import Vue from 'vue';
import axios from "axios";

axios.defaults.baseURL = _server;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || "",
    timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function(config) {
        // Do something before request is sent
        var link = {
            href: config.url
        }

        s.prop1 = _domainLangCode;
        s.prop2 = _domainCntryCode;
        s.prop9 = _prop9;
        s.eVar8 = s.prop9;

        /* start- C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link
         *  * C20190819_65828 : 2019.08.22 김남중 - PC Website Main Promotion Banner 링크 오류 수정
         *    - 아래 로직 전반적으로 수정함.
         *  1. banner: https://dv-us.lgappstv.com/main?lang=engu_US/banner
         *  2. TV앱(게임,,,,,): config.data [catCode1=004&moreYn=N&orderType=0&appRankCode=&curPage=1&rowCount=24&pageCount=10&totalCount=0] 
         *  3. Main(프리미엄,HOT,NEW): main으로 현재 상태로 유지함(취소됨).
         * s.prop13 = document.URL;
         * s.tl(this, 'o', s.getPageName());
         */
    	var sbool = false;
    	var strPagename = "";
    	var surl = document.URL;
        if (config.data != null) {
            var sdata = config.data;
        	//console.log("@@@@ tyep("+typeof(sdata)+ ") prop13["+s.prop13+"] config.data [" + sdata +"] @@@@\n@@@@ config.data.catCode1 [" + sdata.indexOf('catCode1=') +"]/["+sdata.substr(sdata.indexOf('catCode1=')+9, 3)+"] @@@@");
        	try {
        		if (typeof(sdata) == "string") {
        			// 1. banner
        			// Main banner
        			if (sdata.indexOf('banner=') >= 0) {
        				sbool = true;
        				strPagename = "main:banner";
        				if (surl.indexOf('?lang') >= 0) {
        	        		var ssurl = surl.substr(0, surl.indexOf('?lang'));
        	        		s.prop13 = ssurl + "/banner";
        	        	} else {
        	        		s.prop13 = surl + "/banner";
        	        	}
        			} else {
	                	// 2. TV앱(게임,,,,,)
	                	// - TV앱(게임,앤터데인먼트,생활,어학/교육,뉴스/정보: catCode1=002,003,004,005,006): config.data [catCode1=004&moreYn=N&orderType=0&appRankCode=&curPage=1&rowCount=24&pageCount=10&totalCount=0]
	                	//   게임:game, 앤터데인먼트:entertainment, 생활:life, 어학/교육:education, 뉴스/정보:newsinfo
	        			// TVapp Category
	            		if (sdata.indexOf('catCode1=') >= 0) {
		            		sbool = true;
		            		//var catCode = sdata.substr(sdata.indexOf('catCode1=')+9, 3);
		            		if (sdata.indexOf('catCode1=002') == 0) {
		            			strPagename = "main:tvapp:game";
		            			surl = surl + "/game";
		            		} else if (sdata.indexOf('catCode1=003') == 0) {
		            			strPagename = "main:tvapp:entertainment";
		            			surl = surl + "/entertainment";
		            		} else if (sdata.indexOf('catCode1=004') == 0) {
		            			strPagename = "main:tvapp:life";
		            			surl = surl + "/life";
		            		} else if (sdata.indexOf('catCode1=005') == 0) {
		            			strPagename = "main:tvapp:education";
		            			surl = surl + "/education";
		            		} else if (sdata.indexOf('catCode1=006') == 0) {
		            			strPagename = "main:tvapp:newsinfo";
		            			surl = surl + "/newsinfo";
		            		} else {
		            			strPagename = "main:tvapp";
		            		}
		            		s.prop13 = surl;
	            		// banner/TV category외에는 모두 "sbool=false"를 하여 기존과 동일하게 처리됨.
	            		} else {
		            		sbool = false;
		            	}
        			}
        		} else {
        			sbool = false;
        		}
        	} catch (error) {
        		sbool = false;
        	}
            
            // sbool=true : banner/TV앱의 카테고리일 경우
            if (sbool) {
            	s.pageName = strPagename;
            	s.tl(this, 'o', strPagename);
            // sbool=false : banner/TV앱의 카테고리가 아닌 모든 것
            } else {
            	s.pageName = s.getPageName();
            	s.prop13 = document.URL;
            	s.tl(this, 'o', s.getPageName());
            }
        }
        // console.log("pageName ::::::: " + s.getPageName()); //기존
    	console.log("pageName ::::::: " + s.pageName);
        /* end- C20190723_47503 : 2019.08.08 김남중 - 옴니추어 Main Swiper 배너 이미지 Link */
    	
        return config;
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        return response;
    },
    function(error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        },
    });
};

Vue.use(Plugin)

export default Plugin;
